<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="less">
#app {
  width: 100%;
  height: 100%;
  font-family: -apple-system, BlinkMacSystemFont, Helvetica Neue, PingFang SC, Microsoft YaHei, Source Han Sans SC, Noto Sans CJK SC, WenQuanYi Micro Hei, sans-serif;
  color: #1a1a1a;
  margin: 0;
  padding: 0;
  overflow: hidden;
  box-sizing: border-box;
}
.title_bar {
    width: 100%;
    white-space: nowrap; /* 防止换行 */
    overflow: hidden;    /* 隐藏溢出内容 */
}

</style>



// WEBPACK FOOTER //
// src/App.vue